<template>
  <a-card :bordered="false">
    <a-form-model
      :model="ruleForm"
      ref="ruleForm"
      :rules="tabRule"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="应用ID/客户端用户名（clientId）" prop="clientId">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.clientId"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="应用秘钥/客户端密码（clientSecret）" prop="clientSecret">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.clientSecret"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="生成签名密钥（secretKey）" prop="secretKey">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.secretKey"
          :maxLength="100"
        />
      </a-form-model-item>
      <a-form-model-item label="接口请求地址" prop="url">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.url"
          :maxLength="100"
        />
      </a-form-model-item>
      <a-form-model-item label="对接模式" prop="dockingMode">
        <a-radio-group v-model="ruleForm.dockingMode">
          <a-radio :value="0">两方</a-radio>
          <a-radio :value="1">三方</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item style="text-align: center" :wrapper-col="{ span: 9, offset: 3 }">
        <a-button
          htmlType="submit"
          type="primary"
          @click="submitEvent"
          :loading="submitLoading"
        >保存
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import YlHotelMixins from '@/views/service/serviceProvider/ylHotel/mixins/YlHotelMixins'

export default {
  name: 'YlHotelApiConfigure',
  mixins: [YlHotelMixins],
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      ruleForm: {
        dockingMode: 0
      },
      tabRule: {
        clientId: [
          { required: true, message: '请输入应用ID/客户端用户名（clientId）', trigger: ['blur', 'change'] }
        ],
        clientSecret: [
          { required: true, message: '请输入应用秘钥/客户端密码（clientSecret）', trigger: ['blur', 'change'] }
        ],
        secretKey: [
          { required: true, message: '请输入生成签名密钥（secretKey）', trigger: ['blur', 'change'] }
        ],
        url: [
          { required: true, message: '请输入接口请求地址', trigger: ['blur', 'change'] }
        ],
        dockingMode: [
          { required: true, message: '请选择对接模式', trigger: ['blur', 'change'] }
        ]
      },
      submitLoading: false
    }
  },
  mounted() {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo() {
      this.getHttpServices().getServerApiService().post('yilong/queryDetail', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        if (res) this.ruleForm = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        let params = {
          ...this.ruleForm,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }
        const url = params.id ? 'yilong/update' : 'yilong/add'
        this.getHttpServices().getServerApiService().post(url, params).then(res => {
          this.$message.success('API配置成功')
          this.getDetailInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style scoped>

</style>
